module.exports = __webpack_public_path__ + "img/certificate-fail.5983cfd9.svg";